import { countUniquePageVisitsOnClientId } from '../queries/countUniquePageVisitsOnClientId'

export const totalKbVisitorsGauge = {
  queries: [countUniquePageVisitsOnClientId],
  title: 'Total visitors',
}
